import { useEffect, useState } from "react";

// pipes
import { datePipe } from "shared/pipes";
import { ClipboardCopy } from "shared/pipes/clipboard-copy";

// controllers
import { UserController } from "controllers";

// components
import { BoxType } from "./box-type";
import { Feedback } from "./feedback";
import { BoxStatusTag } from "../edit/box-status-tag";

// pipes
import { DisplayDate } from "shared/pipes/display-date";

const NotPickedUpDate = ({ box }) => {
    if (!box.declared_not_picked_up) {
        return null;
    }
    return <p><strong>Declared not picked up:</strong> <DisplayDate>{box.declared_not_picked_up}</DisplayDate></p>;
}

const BoxHeader = ({ box, number, children, withStatus }) => {

    return (
        <>
            <div className="columns is-vcentered">
                <div className="column">
                    <span className="has-tooltip-right">
                        <strong className="is-size-4">
                            <ClipboardCopy value={box.id}>
                                Hack #{number}
                            </ClipboardCopy>
                        </strong>
                    </span>
                </div>

                {withStatus && (
                    <div className="column"> <BoxStatusTag box={box} /> </div>
                )}
            </div>

            <div className="block">
                <p>{box.shipment_week}</p>
                <p>
                    <strong>Created at:</strong> <span data-tooltip={datePipe.transform(box.createdAt.seconds)}>
                        <DisplayDate>
                            {box.createdAt.seconds}
                        </DisplayDate>
                    </span>
                </p>
                <p><strong>To be returned: </strong>
                    <DisplayDate>
                        {box.return_date}
                    </DisplayDate>
                    <NotPickedUpDate box={box} />
                </p>
            </div>

            <div className="block">
                <BoxType box={box} />
            </div>

            {children}
        </>
    );
}

/**
 * Shell for box
 * @param {*}
 * @returns
 */
const Box = ({ customer, box, number, HeaderComponent = BoxHeader, ContentComponent, withStatus }) => {
    const [items, setItems] = useState([]);

    useEffect(() => {
        const getItems = async () => {
            const data = await UserController.getUserBoxItems(customer.id, box.id);
            setItems(data);
        };

        getItems();
    }, [customer, box]);

    return (
        <>
            <div className="columns">
                <div className="column is-3">
                    <HeaderComponent customer={customer} box={box} number={number} withStatus={withStatus} />
                </div>

                <div className="column">
                    <div className="columns is-multiline is-mobile">
                        {items.map((item) => (
                            <div key={item.id} className="column is-3">
                                <ContentComponent item={item} customer={customer} box={box} />
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            <div className="columns">
                <div className="column">
                    <Feedback box={box} />
                </div>
            </div>
        </>
    );
};

export { Box, BoxHeader };
